import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const evIChargeLinkSolarInverter: IMcAppType = {
  name: "evIChargeLinkSolarInverter",
  path: "/my/service/ev-icharge/link-solar-inverter",
  description: "Power Up - Link Solar Inverter",
  navFlow: NavFlow.FOCUS,
  title: "EV Power Up - Link a solar inverter",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "evIChargeLinkSolarInverter",
  },
};

export const evIChargeLinkSolarInverterSetup: IMcAppType = {
  name: "evIChargeLinkSolarInverterSetup",
  path: "/my/service/ev-icharge/link-solar-inverter-setup",
  description: "Power Up - Link Solar Inverter",
  navFlow: NavFlow.FOCUS,
  title: "EV Power Up - Link a solar inverter",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "evIChargeLinkSolarInverterSetup",
  },
};
